import { makeAutoObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

class Sidebar {
  constructor() {
    makeAutoObservable(this);

    makePersistable(this, {
      name: 'sidebar',
      properties: ['isOpen'],
      storage: window.localStorage
    });

    this.toggleSidebar = this.toggleSidebar.bind(this);
  }

  isOpen = true;

  toggleSidebar() {
    this.isOpen = !this.isOpen;
  }
}

const sidebarStore = new Sidebar();

export default sidebarStore;
